<pr-page-splash>
  <div class="flex flex-col items-center">
    <mat-spinner />
    <p>Loading</p>
  </div>
</pr-page-splash>
